<div class="gallery-wrapper">
  @if ( ((screenSize$ | async) !== 'phone' && desktopVariant === 'default') || ((screenSize$ | async) === 'phone' &&
  mobileVariant === 'default') ) {
  <div class="gallery-default-container" [class]="{ zoomable: enableZoom, zoomed: zoomed }">
    <div class="slider-elements">
      <swiper
        [config]="swiperOptions"
        (swiper)="sliderInit()"
        (slideChange)="sliderChange($event)"
        class="slider-swiper"
        #swiperSlider>
        @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <ng-template swiperSlide>
          <div class="swiper-slide-item-wrapper cursor-pointer" (click)="toggleZoom(i)">
            <div class="swiper-slide-item">
              <ng-container *ngTemplateOutlet="slide"></ng-container>
            </div>
          </div>
        </ng-template>
        }
      </swiper>
    </div>
    @if (showSlideNav || showSlideControl) {
    <div class="slider-meta">
      @if (showSlideNav) {
      <div class="slider-meta-dots">
        @if (slides) { @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <div
          class="slider-dots-item"
          [class]="{ 'slider-item-active': i + 1 === slideActive }"
          (click)="sliderSlide(i)"></div>
        } }
      </div>
      } @if (showSlideControl) {
      <div class="slider-meta-buttons">
        @if (!((slideActive ?? 0) <= 1)) {
        <div class="slider-elements-control slider-elements-control-previous" (click)="sliderPrevious()">
          <mat-icon class="chevron-left default">chevron_left</mat-icon>
        </div>
        } @if ((slideActive ?? 0) + (slideVisibleCount ?? 0) - 1 < (slideCount ?? 0)) {
        <div class="slider-elements-control slider-elements-control-next" (click)="sliderNext()">
          <mat-icon class="chevron-right default">chevron_left</mat-icon>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  } @if ((screenSize$ | async) === 'phone' && mobileVariant === 'cards') {
  <div class="gallery-cards-container">
    <div class="swiper-content" (click)="toggleZoom()">
      <swiper
        [config]="swiperOptions"
        (swiper)="sliderInit()"
        (slideChange)="sliderChange($event)"
        class="swiper-slider swiper-card-slider"
        [style]="{ 'z-index': moveToBack ? -1 : 1 }"
        #swiperSlider>
        @for (slide of slides; track identifyByIndex($index)) {
        <ng-template swiperSlide>
          <div class="gallery-item">
            <ng-container *ngTemplateOutlet="slide"></ng-container>
          </div>
        </ng-template>
        }
      </swiper>
    </div>
  </div>
  } @if ((screenSize$ | async) !== 'phone' && desktopVariant === 'preview') {
  <div class="gallery-preview-container" [class]="{ zoomable: enableZoom, zoomed: zoomed }">
    <div class="slider-elements">
      <swiper
        [config]="swiperOptions"
        (swiper)="sliderInit()"
        (slideChange)="sliderChange($event)"
        class="slider-swiper"
        #swiperSlider>
        @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <ng-template swiperSlide>
          <div class="swiper-slide-item-wrapper cursor-pointer" (click)="toggleZoom(i)">
            <div class="swiper-slide-item">
              <ng-container *ngTemplateOutlet="slide"></ng-container>
            </div>
          </div>
        </ng-template>
        }
      </swiper>
    </div>
    @if (showSlideNav) {
    <div class="slider-meta">
      <div
        class="slider-elements-control slider-elements-control-previous"
        [class]="{ 'slider-elements-control-disabled': (slideActive ?? 0) <= 1 }"
        (click)="sliderPrevious()">
        <mat-icon class="chevron-left">chevron_left</mat-icon>
      </div>
      <div class="slider-meta-previews" id="sliderMetaUnzoomedPreviews">
        @if (slides) { @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <div class="slider-previews-wrapper" [id]="'sliderMetaUnzoomedPreviews' + (i + 1)">
          <div
            class="slider-previews-item"
            [class]="{ 'slider-item-active': i + 1 === slideActive }"
            (click)="sliderSlide(i)">
            <ng-container *ngTemplateOutlet="slide"></ng-container>
          </div>
        </div>
        } }
      </div>
      <div
        class="slider-elements-control slider-elements-control-next"
        [class]="{ 'slider-elements-control-disabled': (slideActive ?? 0) >= (slideCount ?? 0) }"
        (click)="sliderNext()">
        <mat-icon class="chevron-right">chevron_left</mat-icon>
      </div>
    </div>
    }
  </div>
  } @if ((screenSize$ | async) !== 'phone' && desktopVariant === 'list') {
  <div class="gallery-list-container" [class]="{ zoomable: enableZoom, 'aspect-less': !forceAspectRatio }">
    @if (slidesActive) {
    <div class="gallery-content">
      @for (slide of slidesActive; track identifyByIndex(i); let i = $index) {
      <div class="gallery-item" [class]="{ zoomed: zoomed && zoomedIndex === i }" (click)="toggleZoom(i)">
        <div class="gallery-item-inner zoomed-background">
          <ng-container *ngTemplateOutlet="slide"></ng-container>
        </div>
      </div>
      }
    </div>
    }
    <div class="gallery-expand">
      @if (expandable) {
      <a class="expandable-button" (click)="expanded ? showLess() : showMore()">
        @if (!expanded) {
        <ng-container i18n="@@uiElements-swiper-more"> + Alle anzeigen ({{ slides?.length ?? '0' }}) </ng-container>
        } @if (expanded) {
        <ng-container i18n="@@uiElements-swiper-less">- Weniger anzeigen</ng-container>
        }
      </a>
      }
    </div>
  </div>
  }
</div>
